import GeomTool from "../geom/GeomTool";


/**
 * Provides utility functions for math operations, mostly about random operations
 * @module MathTool
 */
export default class MathTool{
    /**
     * @returns A random number between 0 and 1
     */
    static random(){
        if( fxrand )
            return fxrand();
        else
            return Math.random();
    }

    /**
     * 
     * @param {Number} max 
     * @param {Number} min 
     * @returns {Number} A random integer between min and max
     */
    static randInt(max=1, min=0 ){
        let num = MathTool.random();
        return Math.round( MathTool.map(num, 0, 1, min, max) );
    }

    // sort: false=no sort; "DESC"=descending; "ASC"=ascending
    static getRandomValues( length, max=1, min=0, sort=false ){
        let values = [];
        for (let i = 0; i < length; i++) {
            values.push( MathTool.map( MathTool.random(), 0, 1, min, max ) );
        }
        if( sort === "DESC" )
            values.sort( (a,b) => a-b );
        else if( sort === "ASC" )
            values.sort( (a,b) => b-a );

        return values;
    }

    static getPolarNoiseArray(length, noiseMax, phase, scale ){
        const angleStep = Math.PI * 2 / length;
        let values = [];        
        for (let i = 0; i < length; i++) {
            let angle = i * angleStep;
            let xoff = MathTool.map( Math.cos( angle ), -1, 1, 0, noiseMax);
            let yoff = MathTool.map( Math.sin( angle ), -1, 1, 0, noiseMax);
            let noise = p5App.noise( xoff*scale + phase, yoff*scale + phase );
            values.push( noise );
        }
        return values;
    }

    /**
     * 
     * @param {Number} length THe length of the generated array
     * @param {Number} offset The offset value for the noise function
     * @param {Number} scale The noise scale. Lower values will generate smooth changes, higher values will generate more abrupt changes
     * @returns An array of random numbers generated using Perlin noise
     */
    static getNoiseArray(length, offset, scale ){
        let values = [];;
        for (let i = 0; i < length; i++) {
            let noise = p5App.noise( offset + i*scale );
            values.push( noise );
        }
        return values;
    }

    static arrayOfRandomNumbers( length, min=0, max=1 ){
        let result = [];
        for (let i = 0; i < length; i++) {
            let rand = MathTool.random();
            let mapped = MathTool.map( rand, 0, 1, min, max );
            result.push( mapped );            
        }
        return result;
    }
    
    /**
     * PENDING
     **/
    static normRand() {
        var x1, x2, rad;

        do {
            x1 = 2 * MathTool.random() - 1;
            x2 = 2 * MathTool.random() - 1;
            rad = x1 * x1 + x2 * x2;
        } while(rad >= 1 || rad == 0);

        var c = Math.sqrt(-2 * Math.log(rad) / rad);

        return x1 * c;
    }

    /**
     * Returns a random value between 0 and 1, with a higher probability of returning values closer to 0
     * @param {*} factor The exponent of the random function. Higher values will generate a higher probability of returning values closer to 0
     * @param {boolean} signed If true (default), it will only return positive values. If false, it will randomly return positive and negative values. 
     * @returns 
     */
    static weightedRandom(factor=2, signed=true){
        let rand = MathTool.random();
        let value = Math.pow(rand, factor);
        if( !signed )
            value = value*MathTool.randomSign();
        return value;
    }

    /**
     * 
     * @param {*} items Array of items to be shuffled
     * @param {*} probs Array of probabilities for each item. Values must be >0 integers and length must match items length
     * @returns 
     */
    static getWeightedRandomElementFromArray( items, probs ){
        let all = [];
        items.forEach( (item, i)=>{
            for( let j=0; j<probs[i]; j++ ){
                all.push(item);
            }
        } );
        return all[Math.floor(MathTool.random() * all.length)];
    }

    static randomSign(){
        return MathTool.random() > 0.5 ? 1 : -1;
    }

    /**
     * PENDING
     **/
    static randomElementFromArray(array){
        let index = MathTool.randInt(array.length - 1);
        return array[index];
    }
    /**
     * PENDING
     **/
    static extractRandomElementFromArray(array){
        let index = MathTool.randInt(array.length - 1);
        return array.splice(index, 1)[0];
    }
    /**
     * PENDING
     **/
    static extractRandomElementsFromArray(array, num){
        let result = [];
        for (let i = 0; i < num; i++) {
            let element = MathTool.extractRandomElementFromArray(array)
            result.push(element);
        }
        return result;
    }
    // Takes an array of objects of length L, and a number array of probabilities of the same length, where each items represents
      // the probability of that item from the first array being selected.
      // It returns an array with multiple insatnces of the items of the first array, repeated as many times as possible so as to satisfy
      // the probabilities indicated in the second array
      // Adding all the values of the second array should be exactly 100
      /**
       * PENDING
       **/
      static repeatAndDistribute( array, probabilities ){
        if( array.length != probabilities.length ){
            console.error( "Error: array and probabilities must be of equal length" );
            return;
        }
        let result = [];
        for (let i = 0; i < array.length; i++) {
            const element = array[i];
            for (let j = 0; j < probabilities[i]; j++) {
                result.push( element );
            }            
        }
        return result;
      }

    /**
     * PENDING
     **/
      static randomElementsFromArray(array, num){
        let result = [];
        let bucket = [...array];
        for (let i = 0; i < num; i++) {
            let index = MathTool.randInt(bucket.length - 1);
            let element = bucket[index];
            result.push(element);
            bucket.splice(index, 1);
        }
        return result;
    }

    /**
     * PENDING
     **/
    static degToRad( deg ){
        return deg*Math.PI/180;
    }

    static radToDeg( rad ){
        return rad*180/Math.PI;
    }

    /**
     * PENDING
     **/
    static distance( p0, p1 ){
        let distX = p1.x-p0.x;
        let distY = p1.y-p0.y;
        let length = Math.sqrt( distX*distX + distY*distY );
        return length;
    }

    /**
     * PENDING
     **/
    static sliceLine( p0, p1, numSlices ){
        let dist = MathTool.distance( p0, p1 );
        let step = Math.abs(dist / numSlices);
        let result = [];
        for (let i = 0; i < numSlices; i++) {
            const slice = MathTool.shortenLineDistance( p0, p1, step*i);                
            result.push( slice );
        }
        return result;
    }

    // This function comes from this thread: 
    // https://stackoverflow.com/questions/24376951/find-new-coordinates-of-point-on-line-in-javascript
    /**
     * PENDING
     **/
    static shortenLineDistance( p0, p1, pxDistance){
        let fromX = p0.x;
        let fromY = p0.y;
        let toX = p1.x;
        let toY = p1.y;

        //if line is vertical
        if(fromX === toX)
            return {x: toX, y: toY > fromY ? fromY + pxDistance : fromY - pxDistance};

        //if line is horizontal
        if(fromY === toY)
            return {y: toY, x: toX > fromX ? fromX + pxDistance : fromX - pxDistance};

        //get each side of original triangle length
        var adjacent   = toY - fromY;
        var opposite   = toX - fromX;
        var hypotenuse = Math.sqrt(Math.pow(opposite, 2) + Math.pow(adjacent,2));

        //find the angle
        var angle = Math.acos(adjacent/hypotenuse);

        //calculate new opposite and adjacent sides
        var newOpposite = Math.sin(angle) * pxDistance;
        var newAdjacent = Math.cos(angle) * pxDistance;

        //calculate new x/y, see which direction it's going
        var y = fromY + newAdjacent,
            x = fromX - newOpposite;

        return {y: y, x: x};

    }

    // Function source: https://gist.github.com/xposedbones/75ebaef3c10060a3ee3b246166caab56
    /**
     * PENDING
     **/
    static  clamp(input, min, max) {
        return input < min ? min : input > max ? max : input;
      }

      // Function source: https://gist.github.com/xposedbones/75ebaef3c10060a3ee3b246166caab56
      /**
       * PENDING
       **/
      static map(current, in_min, in_max, out_min, out_max) {
        const mapped = ((current - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
        return MathTool.clamp(mapped, out_min, out_max);
      }

      /**
       * PENDING
       **/
      static randomInRange( max, min ){
          let minTemp = min;
          let maxTemp = max;
          min = Math.min( minTemp, maxTemp );
          max = Math.max( minTemp, maxTemp );
          return min + MathTool.random()*(max-min);
      }
}